<template>
  <div id="container">
    <div class="navbar">
      <div class="nav_wrapper margin">
        <h4 class="title">隐私保护策略</h4>
      </div>
    </div>
    <div class="argeement">
      <p class="title1">北京棋开德胜科技有限公司用户服务条款及隐私保护策略</p>
      <p>我们非常重视用户个人信息和隐私权的保护，同时为了遵守国家法律法规及监管规定，也为了向您提供服务及提升服务质量（例如：支持我们设计新服务或完善已有服务功能，为您提供和推荐更为优质或适合的服务），您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。鉴于此，我们希望通过本政策向您说明我们如何收集、使用、保存、共享和转让、保护这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。</p>
      <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本政策中涉及的个人信息包括：真实姓名、手机号码、身份证信息。</p>
      <p>我们仅会出于所述的以下功能或目的，收集、使用您的如下个人信息：</p>
      <p>1、 用户注册及实名认证</p>
      <p>当您注册本后台账号时，我们将收集您的真实姓名、手机号码、身份证信息收集此类信息是为了满足相关法律法规的网络实名制要求并保护您的账号安全。如果您仅需使用基础浏览服务，您可以选择不进行注册及提供上述信息。</p>
      <p>2、 安全管理</p>
      <p>为了保障向您提供的服务的安全稳定运行，预防交易和资金风险，我们需要记录您使用的我们服务类别、方式及相关操作信息。如您不同意我们记录前述信息，可能无法获取更好的用户体验，但不影响核心业务功能的使用。</p>
      <p>3、 改善服务质量</p>
      <p>为提升您的服务体验及改进服务质量，或者为您推荐更优质或更适合的服务，我们将收集您与客户服务团队联系时提供的信息、您参与问卷调查向我们发送的信息。收集这些信息是为了向您提供更好的产品和/或服务并改善用户体验。</p>
      <p>我们可能将您的信息向以下第三方共享：</p>
      <p>1、 您明确同意或授权的第三方；</p>
      <p>2、 司法、行政、执法等部门或国家机构；</p>
      <p>3、 依法设立的行业协会；</p>
      <p>4、 与我们履行相关义务所必需接入的合作方及关联方；</p>
      <p>5、 基于共享目的前提下，我们对接的第三方电子签约平台、CA及公证机构等；</p>
      <p>6、 在涉及合并、分立、收购、资产或业务转让或类似的交易时的对手方；</p>
      <p>7、 向您展示我们提供的商品、服务或推广活动所必需的第三方。</p>
      <p>当我们将您的个人信息与第三方共享时，我们会尽最大可能与第三方签署保密协议，促使该等第三方在使用您信息的过程中对您的信息采取不低于我们保密标准的保密与安全措施，当您因第三方未妥善履行保密义务而遭受损失的，我们将协助您向该第三方寻求赔偿。</p>
      <p>除以下情形外，我们不会将您的个人信息转让给任何公司、组织和个人：</p>
      <p>1、 事先获得您的明确同意或授权；</p>
      <p>2、 根据可适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；</p>
      <p>3、 符合我们、我们的关联方、合作方与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
      <p>4、 在涉及资产转让、收购、兼并、分立、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束。如变更个人信息使用目的时，我们将要求该公司、组织重新取得您的明确同意。</p>
      <p>原则上我们不会将您的信息进行公开披露，以下情形除外：</p>
      <p>1、 根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</p>
      <p>2、 根据法律法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们将会依据所要求的个人信息类型和披露方式公开披露您的个人信息。</p>
      <p>发生下列重大变化情形时，我们会适时对本政策进行更新：</p>
      <p>1、 我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；</p>
      <p>2、 收集、存储、使用个人信息的范围、目的、规则发生变化；</p>
      <p>3、 对外提供个人信息的对象、范围、目的发生变化；</p>
      <p>4、 您访问和管理个人信息的方式发生变化；</p>
      <p>5、 数据安全能力、信息安全风险发生变化；</p>
      <p>6、 用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化；</p>
      <p>7、 其他可能对您的个人信息权益产生重大影响的变化。</p>
      <p>如果本政策的任何条款在任何程度上被认定无效或不可执行，本政策的其余部分不应受其影响且应在法律允许的最大程度内予以执行。本政策中任何无效或不可执行的条款应被另一有效且可执行的条款取代，并且该条款应具有与该不可执行的条款的原意最接近的效力。</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isLogin:false
      }
    },
    components:{
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../components/style/mixin';
  .navbar{
    position: relative;
    width: 100%;
    min-width: 1000px;
    height:75px;
    color: #fff;
    background-color:#303030;
    margin-top: -5px;
    .nav_wrapper{
      position:relative;
      height:100%;
      background: url('../../images/navbar.png') no-repeat center center;
      .title{
        position:relative;
        padding:20px 0px 20px 20px;
        font-weight:bolder;
        font-size:26px;
        color:#fff;
      }
      .title:before{
        position: absolute;
        top: 26px;
        left:0px;
        bottom: 1px;
        display: inline-block;
        content: '';
        height:24px;
        content:'';
        border-left:4px solid #ffdb17;
        margin-right:28px;
      }
    }
  }
  .argeement{padding: 30px 300px}
  .argeement p{margin-top: 10px}
  .title1{font-size: 26px;font-weight: bold}
  .title2{font-weight: bold;font-size: 20px}
</style>
